import settings from '@/settings'

let precosPorPosto = (cnpjPosto, headers) => {
  return fetch(`${settings.apetrusApi}/precoscombustivel/porposto/?cnpj=${cnpjPosto}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let get = () => {
  return fetch(`${settings.apetrusApi}/combustiveis/`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default'
  })
}

let cadastrarPreco = (combustivel, headers) => {
  return fetch(`${settings.apetrusApi}/precoscombustivel/cadastrar/`, {
    method: 'POST',
    body: JSON.stringify(combustivel),
    mode: 'cors',
    headers: headers
  })
}

export default {
  get,
  precosPorPosto,
  cadastrarPreco
}
